import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SITE_ORIGIN } from '../config/site';
import { SEO_DESCRIPTION, SEO_TITLE } from '../config/seo';

const ROUTES = {
  '/': { title: SEO_TITLE, description: SEO_DESCRIPTION },
  '/privacy-policy': {
    title: 'Privacy Policy | Cure8 Studios',
    description:
      'Read how Cure8 Studios collects, uses, and protects personal information when you use our website and services.',
  },
  '/terms-of-service': {
    title: 'Terms of Service | Cure8 Studios',
    description:
      'Terms of service for Cure8 Studios workflow audit, automation, and related professional services.',
  },
};

function setMetaContent(selector, content, attr = 'content') {
  const el = document.querySelector(selector);
  if (el) el.setAttribute(attr, content);
}

/**
 * Updates document title, meta description, Open Graph, and Twitter tags on client-side navigation (SPA).
 */
export default function DocumentMeta() {
  const { pathname } = useLocation();

  useEffect(() => {
    const config = ROUTES[pathname] || ROUTES['/'];
    document.title = config.title;
    setMetaContent('meta[name="description"]', config.description);

    const pageUrl = `${SITE_ORIGIN}${pathname === '/' ? '/' : pathname}`;
    setMetaContent('link[rel="canonical"]', pageUrl, 'href');
    setMetaContent('meta[property="og:url"]', pageUrl);
    setMetaContent('meta[property="og:title"]', config.title);
    setMetaContent('meta[property="og:description"]', config.description);
    setMetaContent('meta[name="twitter:title"]', config.title);
    setMetaContent('meta[name="twitter:description"]', config.description);
  }, [pathname]);

  return null;
}
